import { useCurrentUser, useTenantId } from '@api/application-configuration';
import * as Sentry from '@sentry/react-native';
import { isEmbeddedLaunch, updateId } from 'expo-updates';
import { useEffect } from 'react';

const scope = Sentry.getGlobalScope();

/**
 * Enrich Sentry logs with tenantId and user information.
 */
export const useSentryLogEnricher = () => {
  const tenantId = useTenantId();
  const user = useCurrentUser();

  useEffect(() => {
    scope.setTag('expo-update-id', updateId);
    scope.setTag('expo-is-embedded-update', isEmbeddedLaunch);

    if (tenantId) {
      scope.setTag('tenantId', tenantId);
    }

    if (user?.isAuthenticated) {
      scope.setUser({
        id: user.id!,
        email: user.email ?? undefined,
        username: user.userName ?? undefined
      });
    }
  }, [tenantId, user]);
};
